import styled from 'styled-components'

export const HeaderBox = styled.section`
  padding: 0;
  margin: 0;
  border-bottom: 1px solid ${p => p.theme.grey10};
  h2 {
    /* margin-top: 25px; */
    /* margin-bottom: 40px; */
    /* padding: 15px 20px; */
    font-size: 16px;
    line-height: 20px;
    margin: 0;
    padding: 15px 20px;
    border-bottom: solid 1px ${({theme}) => theme.grey10};
  }

  h6 {
    font-weight: normal;
    font-size: ${p => p.theme.fontSizeS};
    color: ${p => p.theme.grey65};
    margin: 0 0 10px;
  }

  ul {
    padding: 15px 20px;
    margin: 0;
    max-width: 1450px;
    list-style: none;
    display: flex;
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 50px;
    @media (max-width: 800px) {
      grid-template-rows: 1fr 1fr;
      grid-template-columns: 1fr 1fr;
    }
    @media (max-width: 600px) {
      grid-template-rows: fit-content(100px) 1fr 1fr 1fr;
      grid-template-columns: auto;
    }
    li {
      font-size: ${p => p.theme.fontSize};
      line-height: 20px;
      flex: 1;
      p {
        display: flex;
        font-weight: bold;
        min-height: 30px;
        align-items: center;
        margin: 0;
        line-height: ${p => p.theme.lineHeightCompact};
        span {
          /* Copy icons */
          margin-left: 5px;
        }
      }
    }
  }
`

export const Content = styled.div`
  display: flex;
`
export const Menu = styled.div`
  padding: 30px;
  border-right: 1px solid ${p => p.theme.grey10};
  min-width: 250px;
  h3:first-of-type {
    margin-top: 0px;
  }
  h3 {
    color: ${({theme}) => theme.grey50};
    font-size: ${({theme}) => theme.fontSizeS};
    font-weight: normal;
    margin-top: 40px;
  }
  ul {
    list-style-type: none;
    padding: 0;
    li {
      margin-bottom: 15px;
      a.active {
        color: ${({theme}) => theme.blue};
        border-left: solid 3px ${({theme}) => theme.blue};
        padding-left: 10px;
        margin-left: -13px;
      }
    }
  }
`

export const Main = styled.div`
  margin: 20px;
  flex-grow: 1;
  overflow: auto;
`

export const IconHeading = styled.h3`
  margin: 0 0 30px;
  font-size: ${p => p.theme.fontSizeL};
  align-items: center;
  display: flex;
  line-height: 1;
  svg {
    margin: 0 10px 0 0;
    color: ${p => p.theme.grey50};
  }
`

export const InfoBox = styled.section`
  margin: 15px 20px;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid ${p => p.theme.grey10};

  > header {
    display: flex;
    > ${IconHeading} {
      margin: 0 20px 0 0;
      flex: 1;
    }
  }
  h6 {
    font-weight: normal;
    font-size: ${p => p.theme.fontSizeS};
    color: ${p => p.theme.grey50};
    margin: 0 0 10px;
  }
  ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 50px;
    @media (max-width: 800px) {
      grid-template-rows: 1fr 1fr;
      grid-template-columns: 1fr 1fr;
    }
    @media (max-width: 600px) {
      grid-template-rows: fit-content(100px) 1fr 1fr 1fr;
      grid-template-columns: auto;
    }
    li {
      font-size: ${p => p.theme.fontSizeL};
      flex: 1;
      p {
        margin: 0 0 5px;
        line-height: ${p => p.theme.lineHeightCompact};
        span {
          line-height: ${p => p.theme.lineHeightCompact};
        }
      }
    }
  }
`

export const SectionInfo = styled.div`
  color: ${p => p.theme.grey50};
  margin: 0 0 20px;
  max-width: 600px;
  p {
    margin: 0 0 0.5em;
    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const Section = styled.section`
  background: ${p => p.theme.grey05};
  border-radius: ${p => p.theme.borderRadius};
  margin: 0 0 30px;
  padding: 30px;
  min-width: 400px;
  max-width: 100%;
  > header {
    display: flex;
    > ${IconHeading} {
      flex: 1;
      margin: 0 20px 15px 0;
    }
    nav {
    }
  }
`

export const SectionContent = styled.div`
  width: 100%;
`
export const DeleteLink = styled.a``
export const Mono = styled.span`
  font-family: atomic___SanFranciscoMono, monospace;
`
